import { createMoneyFormatter } from "@simpro/ui";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { salonProfileQuery } from "../api/salon.queries";

/**
 * Formats a price in the salon's own currency (`salon.currency`, TDD-SA FR-SA-011). Money stays a
 * string from the server; this only presents it. Until the profile has loaded, prices read in the
 * platform default, which is what every salon uses today.
 *
 * Whole prices read without paise ("₹450") unless the salon has chosen to always show them
 * (`salon.public.always_show_decimals`, FR-SA-140); a price with paise always keeps them.
 */
export function useSalonMoney(): (amount: string) => string {
  const { data } = useQuery(salonProfileQuery());
  const currency = data?.currency;
  const decimals = data?.alwaysShowDecimals ?? false;
  return useMemo(
    () => createMoneyFormatter({ currency, minimumFractionDigits: decimals ? 2 : 0 }),
    [currency, decimals],
  );
}
